import {Locale} from '@/utils/constants'
import {useLanguage} from '@/utils/i18n/language'
import {routeTo} from '@/utils/router'

import {
  getLegalServiceCard,
  getMonitoringCard,
  getRegistrationCard,
  getTmRenewalCard,
} from './e2eBrandProtectionCards'
import {getHowItWorksContent} from './marketing-pages/howItWorks'
import {getTmImportanceContent} from './marketing-pages/tmImportance'

const countryFlags: Record<
  number,
  {position: {top: string; left: string}; isHighlighted?: boolean}
> = {
  0: {
    position: {
      top: '8px',
      left: '25%',
    },
    isHighlighted: true,
  },
  1: {
    position: {
      top: '155px',
      left: '73%',
    },
    isHighlighted: true,
  },
  2: {
    position: {
      top: '125px',
      left: '26%',
    },
  },
  3: {
    position: {
      top: '95px',
      left: '54%',
    },
  },
  4: {
    position: {
      top: '0',
      left: '62%',
    },
  },
  5: {
    position: {
      top: '210px',
      left: '45%',
    },
  },
  6: {
    position: {
      top: '60px',
      left: '85%',
    },
  },
  7: {
    position: {
      top: '190px',
      left: '6%',
    },
  },
  8: {
    position: {
      top: '78px',
      left: '0',
    },
  },
}

export const useHomepageContent = () => {
  const language = useLanguage()
  const isEnLanguage = language === Locale.en
  return {
    metaTitle: 'home-title',
    metaDescription: 'home-meta',
    header: {
      buttonLinkText: 'button-start-with-registration',
      buttonLinkHref: routeTo.verification.form(),
    },
    hero: {
      title: 'homepage-hero-title',
      subtitle: 'homepage-hero-subtitle',
      imageSrc: '/images/hero/ice-cream.svg',
      imageAlt: 'Ice cream',
      primaryButtonLink: routeTo.verification.form(),
      primaryButtonText: 'button-start-with-lawyer-check',
      pricingButtonLink: routeTo.pricing(),
      pricingButtonText: 'button-show-price-list',
      list: ['hero-list-item-0', 'hero-list-item-1', 'hero-list-item-2'],
    },
    clientsTitle: 'number-of-registered-tm-title',
    cards: {
      title: 'brand-protection-cards-title',
      list: [
        getRegistrationCard(),
        getLegalServiceCard(),
        {...(isEnLanguage ? getMonitoringCard() : getTmRenewalCard())},
      ],
      showMoreButtonText: 'show-more-text',
    },
    countriesOffer: {
      title: 'offering-all-countries-title',
      description: 'offering-all-countries-desc',
      flags: countryFlags,
    },
    whyRegisterTm: getTmImportanceContent(),
    howItWorks: {
      title: 'how-it-works-title',
      description: 'marketing-pages-common.how-it-works-description',
      steps: getHowItWorksContent().process.steps.map(
        ({title, duration, description, iconSrc, iconAlt}) => ({
          title,
          duration,
          description,
          iconSrc,
          iconAlt,
        }),
      ),
      // 'learn-more-text' is on Lighthouse's non-descriptive link-text blocklist, and anchor text
      // is a ranking signal for the page it points at. This key is already translated everywhere.
      buttonText: 'button-see-how-we-work',
      buttonLink: routeTo.howItWorks(),
    },
    getStartedBanner: {
      title: 'get-started-banner-title',
      imageSrc: '/images/ice-cream-melt.svg',
      imageAlt: 'Ice cream melt',
      primaryButtonLink: routeTo.verification.form(),
      primaryButtonText: 'get-started-banner-button',
    },
    closeButtonText: 'close-btn-text',
  }
}
